// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.os-theme_005d41d9.os-theme_005d41d9 {
  --os-size: 16px;
  --os-padding-perpendicular: 4px;
  --os-padding-axis: 4px;
  --os-track-border-radius: 4px;
  --os-handle-interactive-area-offset: 0;
  --os-handle-border-radius: 4px;
}
[data-overlayscrollbars="host"][aria-disabled="true"] .os-theme_005d41d9.os-theme_005d41d9 {
  --os-handle-bg: #c1c8cd;
  --os-handle-bg-hover: #c1c8cd;
  --os-handle-bg-active: #c1c8cd;
  --os-track-bg: #dce1e5;
  --os-track-bg-hover: #dce1e5;
  --os-track-bg-active: #dce1e5;
}
[data-overlayscrollbars="host"][aria-readonly="true"] .os-theme_005d41d9.os-theme_005d41d9,
[data-overlayscrollbars="host"][aria-busy="true"] .os-theme_005d41d9.os-theme_005d41d9 {
  --os-handle-bg: #84919b;
  --os-handle-bg-hover: #657682;
  --os-handle-bg-active: #657682;
  --os-track-bg: #dce1e5;
  --os-track-bg-hover: #dce1e5;
  --os-track-bg-active: #dce1e5;
}
.os-theme_005d41d9.os-theme-dark_005d41d9 {
  --os-handle-bg: #84919b;
  --os-handle-bg-hover: #657682;
  --os-handle-bg-active: #657682;
  --os-track-bg: #eaedef;
  --os-track-bg-hover: #eaedef;
  --os-track-bg-active: #eaedef;
}
.os-theme_005d41d9.os-theme-light_005d41d9 {
  --os-handle-bg: #eaedef;
  --os-handle-bg-hover: #eaedef;
  --os-handle-bg-active: #eaedef;
  --os-track-bg: #84919b;
  --os-track-bg-hover: #84919b;
  --os-track-bg-active: #84919b;
}
.scroll-arrow-icon_005d41d9 {
  opacity: 0;
  transition: opacity 0.3s linear;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.scroll-arrow-left_005d41d9 {
  left: 0;
  background: linear-gradient(to left, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scroll-arrow-right_005d41d9 {
  right: 0;
  background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scroll-arrow_005d41d9 {
  font-size: 2.167rem;
  position: absolute;
  top: 0;
  bottom: 0;
  border: none;
  width: 4rem;
  transition: background 0.3s linear;
  cursor: pointer;
}
.scroll-arrow_005d41d9:hover {
  background: rgba(220,225,229,0.8);
}
.scroll-arrow_005d41d9:hover .scroll-arrow-icon_005d41d9 {
  opacity: 1;
}
.scroll-arrow-container_005d41d9 {
  position: relative;
}
.scroll-safari-fix_005d41d9 .os-scrollbar-track {
  position: relative;
  overflow: hidden;
  contain: layout;
}
.scroll-safari-fix_005d41d9 .os-host {
  overscroll-behavior: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"os-theme": `os-theme_005d41d9`,
	"os-theme-dark": `os-theme-dark_005d41d9`,
	"os-theme-light": `os-theme-light_005d41d9`,
	"scroll-arrow-icon": `scroll-arrow-icon_005d41d9`,
	"scroll-arrow-left": `scroll-arrow-left_005d41d9`,
	"scroll-arrow-right": `scroll-arrow-right_005d41d9`,
	"scroll-arrow": `scroll-arrow_005d41d9`,
	"scroll-arrow-container": `scroll-arrow-container_005d41d9`,
	"scroll-safari-fix": `scroll-safari-fix_005d41d9`
};
export default ___CSS_LOADER_EXPORT___;
